import ka from './../translations/websites/allmenu/ka.json'
import en from './../translations/websites/allmenu/en.json'
import ru from './../translations/websites/allmenu/ru.json'

export default {
    ka,
    en,
    ru
}